import { getUserBalanceApi } from '@/api/user';
const state = {
  userbalance: null,
};

const mutations = {
  SETUSERBALANCE: (state, balance) => {
    state.userbalance = balance;
  },
};

const actions = {
  GetUserBalance({ commit }, response) {
    return new Promise((resolve, reject) => {
      getUserBalanceApi(response)
        .then((res) => {
          console.log("SETUSERBALANCE",res.data)
          commit('SETUSERBALANCE', res.data);
          resolve(res)
        })
        .catch((err) => {
          console.log(err);
          //   reject(err);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
};
